<!-- yhub app 设备操作记录 -->
<template>
  <div class="event_logs">
    <el-table id="btUpdateInfoTable" :data="tableData" style="width: 100%" border>
      <el-table-column prop="type" :label="$t('AllDevices.Type')" align="center">
        <template slot-scope="scope">
          {{ $t('charger.app_event_' + scope.row.type) }}
        </template>
      </el-table-column>

      <el-table-column prop="rawData" :label="$t('charger.content')" align="center">
        <template slot-scope="scope">
          {{ rawHandle(scope.row.rawData, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('warningPage.CreatedAt')" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime | timef }}
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('adminView.UpdateBy')" align="center" />
    </el-table>

    <el-pagination style="margin-top: 20px;" background :current-page.sync="pageInfo.current" :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size" layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.total"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import { pageDeviceEventLog } from '@/api/blueTooth'
// import { timeFormat } from '@/filters'
import { getDateAndHour } from '@/utils/updateTime.js'
import {getModuleValueMap} from "@/api/i18n"
export default {
  components: {},
  props: ['selectDay', 'sn'],
  data () {
    return {
      tableData: [],
      pageInfo: {
        current: 1,
        total: 0,
        size: 10
      }
    };
  },
  watch: {
    selectDay (newValue, oldValue) {
      this.initData()
    }
  },
  filters: {
    timef (val) {
      return getDateAndHour(val)
    },
    
  },
  mounted () {
    // this.initData()
    this.getCmdOptions()
  },
  methods: {
    getCmdOptions () {
      const lang = this.$i18n.locale
      getModuleValueMap(lang, 'yhub-app', 'config').then(res => {
        console.log(res)
        this.initData()
        if (res.resultCode == 1001) {
          const obj = res.resultModel
          this.$i18n.setLocaleMessage(lang, Object.assign(this.$i18n.messages[lang], {'yhubAppConfig': obj}));
        }
      })
    },
    rawHandle (val, type) {
      // 时间校准
      if (type == 1 && val) {
        return getDateAndHour(val * 1000)
      }
      // 预约充电
      if (type == 2 && val) {
        const obj = JSON.parse(val)
        const types = ['Cancel', 'Single', 'Repeat']
        return obj.startTime + '~' + obj.endTime + ' | '+ types[obj.type]
      }
      // 设置输出电压电流
      if (type == 11 && val) {
        const obj = JSON.parse(val)
        const types = ['','Close', '50%', '75%', '100%', 'All']
        return obj.voltage + 'V / ' + obj.current + 'A / Soc: '+ types[obj.socVal]
      }
      // 搜索页发现
      if (type == 13 && val) {
        const obj = JSON.parse(val)
        // return obj
        return 'Valtage:' + obj.valtage + 'V / Current:' + obj.current + 'A / Soc: '+ obj.soc + '%'
      }

      if (type == 14 && val) {
        const obj = JSON.parse(val)
        return this.$t('yhubAppConfig.cmd'+ obj.deviceControlCmd)
        
      }
      return val
    },
    // 分页----start
    handleSizeChange (val, e) {
      this.pageInfo.size = val
      this.initData()
    },
    handleCurrentChange (val, e) {
      this.pageInfo.current = val
      this.initData()
    },
    initData () {
      var param = {
        'deviceSn': this.sn,
        'endDate': '',
        'startDate': '',
        'type': '',
        pageNum: this.pageInfo.current, // 分页--选中某一页
        pageSize: this.pageInfo.size // 分页--每一页的列表的行数 10 20 50
      }
      // this.loading = true
      // console.log(this.selectDay)
      if (this.selectDay && this.selectDay.length > 0) {
        param.startDate = new Date(this.selectDay[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      }
      pageDeviceEventLog(param).then(res => { // 基本信息
        console.log('操作记录', res)
        // this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          this.tableData = res.resultModel.list
          this.pageInfo.total = res.resultModel.total
          this.pageInfo.current = res.resultModel.pageNum
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped></style>